/** Shown when the server rejects a position as too inaccurate. */
export const POOR_SIGNAL_MESSAGE =
  'GPS signal is too fuzzy here. Try moving near a window or somewhere more open, then try again.';
